/**
 * The files a generation tool just made, read from its result. No React here:
 * the turn fold (turnFold.ts) needs this too, and it can be tested alone.
 */
import { toWorkspaceRelPath } from './fileRefs';

/** Tools whose result names what they made. `screenshot` is not one: that is the agent checking its own work. */
export const GENERATION_TOOLS: ReadonlySet<string> = new Set([
  'generate_image',
  'edit_image',
  'remove_background',
  'render_image',
  'generate_icon_set',
  'generate_video',
  'check_video',
  'generate_voiceover',
  'design_voice',
  'generate_sound_effect',
  'isolate_audio',
  'generate_music',
  'batch_render_video',
  'batch_screenshot',
  'vc_render_status',
  'vc_get_preview',
]);

/** One file: `sheet` is an icon set's review sheet, `workspacePath` a scene preview's `ws://` path. */
const FILE_FIELDS = ['savedPath', 'savedPreviewPath', 'workspacePath', 'sheet'];
/** A batch's rows, each with its own `savedPath` or `error`. */
const ROW_FIELDS = ['images', 'videos', 'shots'];

/** Workspace paths of what a tool made, in order; none for a failed call or one still pending. */
export function generatedPaths(result: unknown): string[] {
  if (typeof result !== 'object' || result === null) return [];
  const r = result as Record<string, unknown>;
  if (r.error || r.ok === false) return [];

  const found: unknown[] = FILE_FIELDS.map((field) => r[field]);
  if (Array.isArray(r.savedPaths)) found.push(...r.savedPaths);
  for (const field of ROW_FIELDS) {
    const rows = r[field];
    if (!Array.isArray(rows)) continue;
    for (const row of rows) if (row && !row.error) found.push(row.savedPath);
  }

  const paths = found.map((p) => (typeof p === 'string' ? toWorkspaceRelPath(p) : null));
  return [...new Set(paths.filter((p): p is string => !!p))];
}
